import React from 'react'
import { Link } from 'react-router-dom'

import SEO from '../components/SEO'
import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './projeler.css'

const Projeler = () => {
  const projects = [
    {
      title: 'Şeffaf TPU PPF Boya Koruma',
      category: 'PPF KORUMA',
      description: 'Yol taşları ve dış etkenlere karşı gövde panellerinin özenli kenar kıvırma işçiliğiyle şeffaf koruma altına alınması.',
      imgSrc: 'https://images.pexels.com/photos/36021355/pexels-photo-36021355.jpeg?auto=compress&cs=tinysrgb&w=1500',
      imgAlt: 'Stüdyoda spor araca şeffaf PPF kaplama uygulanması',
      tags: ['PPF', 'Yüzey Koruma', 'Optik Berraklık'],
      link: '/ppf-kaplama',
    },
    {
      title: 'Premium Dökme Cast Folyo Renk Değişimi',
      category: 'ARAÇ KAPLAMA',
      description: 'Gövde hatlarına tam oturan dökme vinil folyo ile kusursuz panel bitişleri ve estetik renk dönüşümü.',
      imgSrc: 'https://images.pexels.com/photos/10162529/pexels-photo-10162529.jpeg?auto=compress&cs=tinysrgb&w=1500',
      imgAlt: 'Özel renk folyo araç kaplama çalışması',
      tags: ['Cast Folyo', 'Renk Değişimi', 'Panel Bitişleri'],
      link: '/arac-kaplama',
    },
    {
      title: 'Çok Aşamalı Boya Düzeltme & Seramik Koruma',
      category: 'SERAMİK & POLİSAJ',
      description: 'Kılcal çizik ve harelerin giderilmesinin ardından uygulanan seramik kaplama ile derin ve kalıcı ayna parlaklığı.',
      imgSrc: 'https://images.pexels.com/photos/14231701/pexels-photo-14231701.jpeg?auto=compress&cs=tinysrgb&w=1500',
      imgAlt: 'Boya düzeltme ve seramik kaplama sonrası ayna yansıması',
      tags: ['Boya Düzeltme', 'Seramik Kaplama', 'Derin Parlaklık'],
      link: '/seramik-kaplama',
    },
    {
      title: 'Detaylı İç Restorasyon & Deri Kondisyonlama',
      category: 'İÇ DETAILING',
      description: 'Deri koltukların pH dengeli arındırıcılarla temizlenip mat besleyici losyonlarla korunması ve hijyen sterilizasyonu.',
      imgSrc: 'https://images.pexels.com/photos/20042054/pexels-photo-20042054.jpeg?auto=compress&cs=tinysrgb&w=1500',
      imgAlt: 'İç mekan deri döşeme detaylı temizlik ve kondisyonlama',
      tags: ['Deri Bakımı', 'Buharlı Hijyen', 'İç Detailing'],
      link: '/detayli-arac-temizligi',
    },
    {
      title: 'Kusursuz Yüzey Hazırlığı ve Polisaj',
      category: 'POLİSAJ',
      description: 'Dual-action ve rotary polisaj makineleriyle vernik tabakasına zarar vermeden uygulanan hassas finisaj.',
      imgSrc: 'https://images.pexels.com/photos/11139244/pexels-photo-11139244.jpeg?auto=compress&cs=tinysrgb&w=1500',
      imgAlt: 'Profesyonel polisaj ve pasta cila aşaması',
      tags: ['Polisaj', 'Pasta Cila', 'Hare Giderme'],
      link: '/polisaj',
    },
    {
      title: 'Kaput Altı Detaylı Motor Temizliği & Koruma',
      category: 'MOTOR KORUMA',
      description: 'Hassas elektronik aksamlar gözetilerek motor bölmesi yağ arındırma ve koruma uygulaması.',
      imgSrc: 'https://images.pexels.com/photos/15085608/pexels-photo-15085608.jpeg?auto=compress&cs=tinysrgb&w=1500',
      imgAlt: 'Kaput altı ve motor bölmesi detaylı temizlik ve koruma çalışması',
      tags: ['Motor Temizliği', 'Yüzey Koruma', 'Detaylı Bakım'],
      link: '/detayli-motor-temizligi',
    },
  ]

  return (
    <div className="projects-container teleport-dashboard-layout">
      <SEO
        title="Tamamlanan Projeler & Uygulamalar | ATEŞ AUTO DETAILING"
        description="Beşiktaş Conrad stüdyomuzda gerçekleştirilen şeffaf PPF kaplama, renk değişimi, seramik koruma ve detaylı araç temizliği çalışma örnekleri."
        canonicalPath="/projeler"
      />

      <aside className="projects-sidebar-wrapper teleport-dashboard-sidebar">
        <Navigation />
      </aside>

      <main id="tq-main" className="projects-content-wrapper teleport-dashboard-content">
        <section className="projects-hero">
          <nav aria-label="Breadcrumb" className="projects-breadcrumb">
            <Link to="/">ANA SAYFA</Link>
            <span className="projects-breadcrumb-separator">/</span>
            <span aria-current="page">PROJELER</span>
          </nav>

          <h1 className="projects-headline">Projeler</h1>

          <p className="projects-description">
            Uygulama yaklaşımımızı ve yüzey detaylarına verdiğimiz önemi gerçek çalışma örnekleri üzerinden inceleyin.
            Her araç, Conrad Istanbul Bosphorus stüdyomuzda yüksek hassasiyetle ele alınmaktadır.
          </p>
        </section>

        <section className="projects-body">
          <div className="projects-grid">
            {projects.map((item, idx) => (
              <article key={idx} className="project-card">
                <div className="project-media-wrapper">
                  <img
                    src={item.imgSrc}
                    alt={item.imgAlt}
                    loading="lazy"
                    decoding="async"
                    className="project-img"
                  />
                  <span className="project-category-badge">{item.category}</span>
                </div>
                <div className="project-content">
                  <h2 className="project-title">{item.title}</h2>
                  <p className="project-desc">{item.description}</p>
                  <div className="project-tags">
                    {item.tags.map((tag, tIdx) => (
                      <span key={tIdx} className="project-tag">{tag}</span>
                    ))}
                  </div>
                  <Link to={item.link} className="project-link-action">
                    Hizmet Detayını İncele →
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </section>

        <Footer />
      </main>
    </div>
  )
}

export default Projeler
